export const ROUTE_PATHS = {
    FEE_EXPLAINER_WORKFLOW: '/fee-explainer-workflow',
    RATE_STRING_LOGIC_WORKFLOW: '/fee-explainer-workflow/rate-string-logic-workflow',
    FEATURE_EXPRESSION_WORKFLOW: '/fee-explainer-workflow/fe-workflow',
} as const;
